Customer.Filters ||= {}

class Customer.Filters.GroupsView extends Backbone.View
  template: JST['backbone/templates/customer/filters/groups']
  events:
    'click .open-keyword-groups': 'openKeywordGroupsClick'
    'click #cancel-groups-modal-selection': 'cancelGroupsModalSelection'
    'click #groups-modal-selection-done': 'groupsModalSelectionDone'

  initialize: (@options = {}) ->
    @terms = @options.terms
    @shouldTriggerEvents = @options.shouldTriggerEvents
    @hideToggle = @options.hideToggle
    @disableDoneButtonWhenEmpty = @options.disableDoneButtonWhenEmpty
    @customerFilter = @options.customerFilter
    @keywordsFilterView = new Monitoring.Views.SocialContents.Filters.CustomerLabelsFilterView({terms: @terms, customerFilter: @customerFilter  })
    @listenTo(@keywordsFilterView, 'change', @_updateDoneButton) if @disableDoneButtonWhenEmpty

  render: ->
    @$el.html @template
    @_renderKeywordsFilter()
    @_groupsSelectionToggle()
    @$el.find('#keyword-groups-container').html(@keywordsFilterView.render().el)
    @$el.find('.open-keyword-groups').addClass('hidden') if @hideToggle
    @_updateDoneButton() if @options.disableDoneButtonWhenEmpty
    @

  toggle: ->
    @$el.find('#keyword-groups-container').toggleClass('hidden')
    @$el.find('.chevron-up').toggleClass('hidden')
    @$el.find('.chevron-down').toggleClass('hidden')

  openKeywordGroupsClick:(event)->
    @_keepCustomerSessionAlive()
    event.stopPropagation()
    @toggle()
    @_groupsSelectionToggle()
    @_renderKeywordsFilter()


  _groupsSelectionToggle:()->
    if @hasSelectedGroups()
      @$el.find('.no-groups-selected').addClass('hidden')
      @$el.find('.groups-selected').removeClass('hidden')
    else
      @$el.find('.no-groups-selected').removeClass('hidden')
      @$el.find('.groups-selected').addClass('hidden')


  cancelGroupsModalSelection:(event)->
    @_keepCustomerSessionAlive()
    event.stopPropagation()
    @toggle()
    @keywordsFilterView.render()
    @_groupsSelectionToggle()
    @trigger('groups:cancel') if @shouldTriggerEvents

  groupsModalSelectionDone:(event)->
    @_keepCustomerSessionAlive()
    event.preventDefault()
    event.stopImmediatePropagation()
    @toggle()
    @keywordsFilterView.onApply()
    @_groupsSelectionToggle()
    @trigger('groups:done') if @shouldTriggerEvents

  intelligentGroups: ->
    {
      main_groups: @keywordsFilterView.mainGroups, main_groups_logic: @keywordsFilterView.primaryLabelsLogic,
      secondary_groups: @keywordsFilterView.secondaryGroups, secondary_groups_logic: @keywordsFilterView.secondaryLabelsLogic,
      excluded_groups: @keywordsFilterView.excludedGroups, excluded_groups_logic: @keywordsFilterView.excludedLabelsLogic
    }

  hasSelectedGroups:->
    selected = @keywordsFilterView.mainGroups.concat(@keywordsFilterView.secondaryGroups).concat(@keywordsFilterView.excludedGroups)
    selected.length > 0

  _renderKeywordsFilter: ->
    @_groupsSelectionToggle()
    @

  _updateDoneButton: ->
    disabled = !@keywordsFilterView.someValueSelected()
    @$el.find('#groups-modal-selection-done').prop('disabled', disabled)

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
